import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { Constants, UserType } from '../../common';
import { Mapper } from '../mapper/mapper';
import { BasicUser } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class StudentApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getStudentQuery(name: string): Observable<BasicUser[]> {
    const body = { fullName: name, searchType: UserType.STUDENT };
    return this.baseAPI.post(Constants.GET_STUDENT_QUERY_API_URL, body).pipe(
      map((res) => {
        return this.mapper.fromListJson(BasicUser, res.students);
      })
    );
  }
}
